import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

export const Route = createFileRoute("/politique-de-confidentialite")({
  head: () =>
    routeHead({
      path: '/politique-de-confidentialite',
      title: 'Politique de confidentialité | JIIA Studio',
      description: 'Politique de confidentialité et protection des données personnelles du site JIIA Studio.',
    }),
  component: PolitiqueConfidentialite,
});
